import { createContext, useContext } from 'react';

import type { SizeType } from './types';

export type AvatarStackContextType = {
  /** The size of each avatar in the stack. */
  size?: SizeType;
};

export const AvatarStackContext = createContext<AvatarStackContextType | null>(
  null
);
export const useAvatarStackContext = () => {
  return useContext(AvatarStackContext);
};
